import { DateTime } from 'luxon';

export const formatDateTime = (date: DateTime) => {
  const minFormat = date.toFormat('mm') === '00' ? '' : ':mm';
  const timeFormat = `EEE, LLL d 'at' h${minFormat}a ZZZZ`;
  return date.toFormat(timeFormat);
};
